import React, { Component } from 'react'
import { deepSet } from '../../utils'

/**
 *
 * This decorator should create a query param like this
 * filter=[
 * {"sorting":"newest"},
 * {"author":-1},
 * {"channel":-1},
 * {"status":-1},
 * {"templateId":"24"},
 * {"dateType":"createdAt"},
 * {"startDate":-1},
 * {"endDate":-1},
 * {"name":-1}
 * ]
 */
export function filterable(target) {

  const provider = target.prototype || target

  const origUpdateFilter = provider.updateFilter
  const origLoad = provider.load

  provider.updateFilter = function updateFilter(filter) {

    this.reset({ filter })

    if (origUpdateFilter) {
      this:: origUpdateFilter(filter)
    }

  }

  provider.load = function load(id = null, opts = {}, data = {}) {
    if (Object.prototype.toString.call(id) === '[object Object]') {
      data = opts
      opts = id
      id = null
    }

    const useFilter = this.filter
      && (id === undefined || id === null)
      && !opts.noFilter
    const filterDefined = !!opts.params && !!opts.params.filter

    // uses the complex store.filter obj and breaks it into the simplier ~opts.filter
    if (useFilter && !filterDefined) {

      const filter = Object.keys(this.filter)
        .map((name) => ({ [name]: this.filter[name] }))

      // TODO: stringification should probably happen much deeper in the sync module
      deepSet(opts, 'params.filter', JSON.stringify(filter))
    }
    return this:: origLoad(id, opts, data)

  }

}

export function connectToFilterable(BaseComponent, filterableStore) {

  if (!BaseComponent) {
    throw new Error('Argument#1: connectToFilterable expects an BaseComponent as first argument')
  }

  // eslint-disable-next-line no-prototype-builtins
  if (!Component.isPrototypeOf(BaseComponent)) {

    const name = BaseComponent.name
      || BaseComponent.constructor.name
      || BaseComponent.prototype.constructor.name
      || 'undefined'

    // eslint-disable-next-line max-len
    throw new Error(`Argument#1: Should be an instance of React.Component. ${name} (${Object.prototype.toString.apply(BaseComponent)}) given.`)
  }

  if (!filterableStore) {
    throw new Error('Argument#2: connectToFilterable expects an filterableStore as second argument')
  }

  if (!filterableStore.updateFilter) {
    // eslint-disable-next-line max-len
    throw new Error('Argument#2: The given filterableStore doesn\'t define the updateFilter method and thus is not filterable. Decorate the store with the @filterable decorator.')
  }

  class FilterConnection extends Component {

    constructor(props) {
      super(props)
      this.state = {
        filter: {},
      }
      this.handleFilterChanged = this.handleFilterChanged.bind(this)
    }

    handleFilterChanged(filter) {
      this.setState({ filter })
      filterableStore.updateFilter(filter)
    }

    render() {

      return (
        <BaseComponent
          onChange={this.handleFilterChanged}
          {...this.props}
          {...this.state}
        />
      )

    }

  }

  return FilterConnection

}



// WEBPACK FOOTER //
// ./src/shared/api/decorators/filterable.js